import { createApi, type BaseQueryFn } from '@reduxjs/toolkit/query/react'
import { apiClient } from '../../api/client'

type ApiErrorShape = { status: number; code: string; message: string }

const baseQuery: BaseQueryFn<
  { url: string; method?: string; body?: unknown; params?: Record<string, string> },
  unknown,
  ApiErrorShape
> = async ({ url, method = 'GET', body, params }) => {
  const queryString = params
    ? '?' + new URLSearchParams(params).toString()
    : ''

  const result = await apiClient(url + queryString, {
    method,
    body: body ? JSON.stringify(body) : undefined,
  })

  if ('error' in result) {
    return { error: result.error }
  }
  return { data: result.data }
}

export const api = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: ['User', 'Account', 'Sessions', 'Tickets', 'Invoices', 'News', 'Services', 'Faq'],
  endpoints: () => ({}),
})
